import {CommonStatus} from "@/enums/status";
import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class PriceListParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    search?: string;
    status?: CommonStatus;
    postOfficeRowGuid?: string;
}

export class ServiceFeeParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    search?: string;
    status?: CommonStatus;
    provinceId?: number;
}
